// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__2p4vD","link":"Nav_link__8Jtyx","selected":"Nav_selected__2WReS"};